export const album = {
  songs: 'canciones',
  Album: 'Álbum',
  'More by': 'Más de',
};
